/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class PreEnrolmentsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return this.store.query('person', {
      type: PersonType.LEARNER,
      status: EnrolmentStatus.PRE_ENROLLED,
      include: 'enrolments',
    });
  }
}
